import React, { useEffect } from 'react';
import Three from '../Components/Three';
import ContactInfo2 from '../Components/ContactInfo2';
import Socials from '../Components/Socials';
import Plane from '../Bee/Plane';
import BeeSection from '../Bee/BeeSection';

const Contact = () => {
   useEffect(() => {
     window.scrollTo(0, 0); 
   }, []);


   
 
  return (
    
    <div className='bg-[#111111] px-[4vw]'>
    
    <ContactInfo2 />
    <Socials />
  </div>
  );
};

export default Contact;